'use client'
import { subcategoryType } from '@/lib/subcategory'

export const SubcategorySelect = ({
  subcategories,
}: {
  subcategories: subcategoryType[]
}) => {
  if (subcategories.length === 0) {
    return null
  }
  const justifyCenter = subcategories.length < 4 ? 'justify-center' : ''
  return (
    <>
      <div
        className={
          `horizontal-tab-list inline-block overflow-x-auto flex` +
          ' ' +
          justifyCenter
        }
      >
        {subcategories.map((v, index) => (
          <a
            key={index}
            href={`/subcategory/${v.subcategory_id}`}
            className="horizontal-tab-element font-semibold text-[13px] text-gray-600 hover:text-gray-800 hover:bg-gray-200 transition-colors duration-200 ease-in-out bg-[#efefef] rounded-[21px] px-4 py-2 m-1 text-nowrap"
          >
            {v.name}
          </a>
        ))}
      </div>
    </>
  )
}
